<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Insurance Claims</h1>
        <v-alert type="warning" v-if="selectedEmp.remarks != null">{{
          selectedEmp.remarks
        }}</v-alert>
        <emp-image :empCode="selectedEmp.code"></emp-image>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <emp-lookup
              :class-padding="classPadding"
              v-model="selectedEmp"
              label="Employee Code"
              title="Employee"
              :code-value="true"
              :required="true"
            ></emp-lookup>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Name"
              :value="selectedEmp.desc"
              :class="classPadding"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <custom-datepicker
              :class-padding="classPadding"
              label="Date"
              v-model="model.claimDate"
              :required="true"
            ></custom-datepicker>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <insurance-lookup
              :class-padding="classPadding"
              v-model="selectedInsClaim"
              label="Type"
              title="Insurance Claims"
              :required="true"
            ></insurance-lookup>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field autocomplete="off"
              label="Remarks"
              :class="classPadding"
              v-model="model.remarks"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-file-input
              label="Attachment"
              :class="classPadding"
              v-model="attachment"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Add</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <list :emp-code="selectedEmp.code" :key="componentKey">
              <template slot="actions" slot-scope="{ item }">
                <v-btn
                  @click.stop="edit(item)"
                  text
                  icon
                  v-if="userAccess.edit >= 1"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  @click.stop="deleteItem(item)"
                  text
                  icon
                  v-if="userAccess.delete >= 1"
                >
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
              </template>
              <template slot="attachment" slot-scope="{ item }">
                <v-btn @click.stop="viewAttachment(item)" text outlined
                  >View</v-btn
                >
              </template>
            </list>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-dialog v-model="editDialog" width="700" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>
        <v-card-text>
          <br />
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <insurance-lookup
                :class-padding="classPadding"
                v-model="editSelectedInsClaim"
                label="Type"
                title="Insurance Claims"
                :code-value="false"
              ></insurance-lookup>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <custom-datepicker
                :class-padding="classPadding"
                label="Date"
                v-model="editModel.claimDate"
              ></custom-datepicker>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
              <v-text-field autocomplete="off"
                label="Remarks"
                :class="classPadding"
                v-model="editModel.remarks"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-file-input
                label="Attachment"
                :class="classPadding"
                v-model="attachment"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click.stop="editDialog = false"
            >Close</v-btn
          >
          <v-btn
            text
            color="success"
            @click.stop="update"
            :loading="isUpdating"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import EmpLookup from "../../employee-masterfile/personal-info/Lookup";
import CustomDatepicker from "../../../../components/CustomDatepicker";
import InsuranceLookup from "../../../setup/employment-other-info/others/insurance-claim/Lookup";
import List from "./List";
import { viewFileWithLocation } from "../../../../helpers/utility";
import selectEmpMixin from "../../employee-masterfile/personal-info/mixins/selectEmpMixin";
import EmpImage from "../../employee-masterfile/personal-info/Image";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/insuranceClaimMaint";
const FOLDER_NAME = "insuranceClaims";
export default {
  metaInfo: {
    title: "Insurance Claims",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [selectEmpMixin, userAccessMixin],
  data: () => ({
    model: {
      date: new Date().toISOString()
    },
    classPadding: "my-0 py-0",
    selectedEmp: {},
    dateModel: null,
    selectedInsClaim: {},
    editSelectedInsClaim: {},
    isSaving: false,
    componentKey: 0,
    editModel: {},
    editDialog: false,
    attachment: null,
    attachmentDialog: false,
    attachmentImage: null,
    isUpdating: false
  }),
  components: {
    EmpLookup,
    CustomDatepicker,
    InsuranceLookup,
    List,
    EmpImage
  },
  computed: {
    attachmentUrl() {
      if (
        this.attachmentImage == null ||
        typeof this.attachmentImage == "undefined" ||
        this.attachmentImage == ""
      )
        return "";
      else return `data:image/jpeg;base64, ${this.attachmentImage}`;
    }
  },
  methods: {
    save() {
      this.isSaving = true;
      this.model.empCode = this.selectedEmp.code;
      this.model.claimType = this.selectedInsClaim.code;

      var formData = new FormData();
      var data = Object.assign({}, this.model);
      formData.append("json", JSON.stringify(data));
      formData.append("attachment", this.attachment);

      // this.$axios
      //   .post(`${API_ENDPOINT}`, this.model)
      this.$axios({
        method: "POST",
        url: `${API_ENDPOINT}`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      this.editDialog = true;
      this.editModel = Object.assign({}, item);
      this.editSelectedInsClaim = {
        code: item.claimType,
        desc: item.claimTypeDesc
      };
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.id}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.model = {};
      this.forceRerender();
      this.editDialog = false;
      this.selectedInsClaim = {};
      this.model.date = new Date().toISOString();
      this.attachment = null;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      //this.modeel.empCode = this.selectedEmp.code;
      this.editModel.claimType = this.editSelectedInsClaim.code;

      var formData = new FormData();
      var data = Object.assign({}, this.editModel);
      formData.append("json", JSON.stringify(data));
      formData.append("attachment", this.attachment);

      // this.$axios
      //   .post(`${API_ENDPOINT}`, this.model)
      this.$axios({
        method: "PUT",
        url: `${API_ENDPOINT}`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    viewAttachment(item) {
      viewFileWithLocation(
        item.location
      );
    }
  },
  watch: {
    selectedEmp() {
      this.forceRerender();
    }
  },
  created() {
    this.getUserAccessRights("EMFOIICM");
  }
};
</script>